const serviceData = [
  {
    id: 1,
    title: "Self Drive",
    icon: "ri-car-line",
    desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
  },

  {
    id: 2,
    title: "Hire Us For Events",
    icon: "ri-lightbulb-flash-fill",
    desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
  },

  {
    id: 3,
    title: "Be Chauffeured",
    icon: "ri-taxi-fill",
    desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
  },

  

  {
    id: 4,
    title: "Logistics & Deliveries",
    icon: "ri-truck-line",
    desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
  },

 
];

export default serviceData;
